import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import SideNav from "./SideNav";
import { Outlet, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

// layout component
const Layout = () => {
  const [isSideNavOpen, setIsSideNavOpen] = useState(window.innerWidth >= 1200);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 1200);
  const location = useLocation();

  const toggleSideNav = () => setIsSideNavOpen(prev => !prev);

  useEffect(() => {
    const handleResize = () => {
      const isLarge = window.innerWidth >= 1200;
      setIsLargeScreen(isLarge);
      setIsSideNavOpen(isLarge);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // تنظيف التوستات القديمة عند تغيير الصفحة لمنع التراكم
  useEffect(() => {
    // مسح التوستات التي تجاوزت وقتها عند تغيير الصفحة
    // هذا يمنع تراكم التوستات في البيئة الإنتاجية
    const timer = setTimeout(() => {
      // react-toastify يتعامل مع autoClose تلقائياً
      // لكن في البيئة الإنتاجية قد تحتاج تنظيف إضافي
      // لا نمسح كل التوستات هنا لأن بعضها قد يكون جديداً
    }, 100);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  // Set body class for sidebar state (for responsive forms)
  useEffect(() => {
    if (isLargeScreen) {
      if (isSideNavOpen) {
        document.body.classList.add("with-sidenav");
        document.body.classList.remove("full-width");
      } else {
        document.body.classList.add("full-width");
        document.body.classList.remove("with-sidenav");
      }
    } else {
      document.body.classList.remove("with-sidenav");
      document.body.classList.remove("full-width");
    }
    return () => {
      document.body.classList.remove("with-sidenav");
      document.body.classList.remove("full-width");
    };
  }, [isSideNavOpen, isLargeScreen]);

  const contentClass = isLargeScreen
    ? isSideNavOpen
      ? "with-sidenav"
      : "full-width"
    : "";

  const isHomePage = location.pathname === "/";
  const isPOSPage = location.pathname === "/pos";
  const homePageClass = isHomePage ? "homx-page" : "";
  const posPageClass = isPOSPage ? "pos-page" : "";

  return (
    <>
      {!isPOSPage && (
        <Navbar
          toggleSideNav={toggleSideNav}
          isSideNavOpen={isSideNavOpen}
          isLargeScreen={isLargeScreen}
        />
      )}
      {!isPOSPage && (
        <SideNav isOpen={isSideNavOpen} toggleSideNav={toggleSideNav} />
      )}
      {!isLargeScreen && isSideNavOpen && !isPOSPage && (
        <div className="sidenav-overlay active" onClick={toggleSideNav} />
      )}
      <div
        className={`content_wrapper ${contentClass} ${homePageClass} ${posPageClass}`}
      >
        {isPOSPage ? (
          <Outlet />
        ) : (
          <div className="container-fluid">
            <Outlet />
          </div>
        )}
      </div>

      <style jsx="true">{`
        .pos-page {
          padding: 0 !important;
          margin: 0 !important;
          min-height: 100vh !important;
        }

        .pos-page .content_wrapper {
          padding: 0 !important;
          margin: 0 !important;
        }
      `}</style>
    </>
  );
};

export default Layout;
